import { render } from "./SalesYearContainer.vue?vue&type=template&id=16024a45"
import script from "./SalesYearContainer.vue?vue&type=script&lang=js"
export * from "./SalesYearContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__